<div class="tga-card-container">
  <div class="tga-card-header">
    <h1>{{ 'TGA.Advice.Cultivation.FieldObservationImages.Title' | translate }}</h1>
  </div>
  <div class="tga-card-content">
    @if (groupedFieldObservationImages$() | async; as fieldObservationImages) {
      @if (isLoading(fieldObservationImages)) {
        <div class="loading-container">
          <app-loading-card [loadingText]="'BFP.UI.Loading'" />
        </div>
      } @else if (isError(fieldObservationImages)) {
        <div class="error-container">
          <p class="error-message">{{ 'TGA.Advice.Cultivation.FieldObservationImages.Error' | translate }}</p>
        </div>
      } @else if (isLoaded(fieldObservationImages)) {
        @if (
          fieldObservationImages.state === 'loaded' &&
          fieldObservationImages.data &&
          fieldObservationImages.data.length > 0
        ) {
          <!-- Images timeline -->
          <div class="images-timeline-container">
            <div class="timeline-items">
              @for (group of fieldObservationImages.data; track group.key; let last = $last) {
                <div class="timeline-item">
                  <div
                    class="image-bundle"
                    [class.active]="last"
                    tabindex="0"
                    role="button"
                    [attr.aria-label]="
                      group.images.length +
                      ' field observation images from ' +
                      (group.date | date: 'd MMMM yyyy' : undefined : locale())
                    "
                    (click)="onImageClicked(fieldObservationImages.data, group.startIndex, 0)"
                    (keydown)="
                      $event.key === 'Enter' && onImageClicked(fieldObservationImages.data, group.startIndex, 0)
                    "
                  >
                    @if (groupImagesWithContent(group); as imagesWithContent) {
                      @if (imagesWithContent.length > 0) {
                        @for (item of imagesWithContent; track item.imageId; let i = $index) {
                          @if (i < 3) {
                            <div class="bundle-image-slot">
                              <img [src]="item | dataUri" alt="Field observation view" class="bundle-img" />
                              @if (i === 2 && imagesWithContent.length > 3) {
                                <div class="bundle-overlay" aria-hidden="true">
                                  <span>+{{ imagesWithContent.length - 2 }}</span>
                                </div>
                              }
                            </div>
                          }
                        }
                        <span class="bundle-zoom-icon" aria-hidden="true">
                          <mat-icon>search</mat-icon>
                        </span>
                      } @else {
                        <div class="bundle-no-image" aria-hidden="true">
                          <mat-icon>image_not_supported</mat-icon>
                          <span>{{ noImageMessage() }}</span>
                        </div>
                      }
                    }
                  </div>
                  <div class="timeline-marker" [class.active]="last">
                    <div class="marker-dot"></div>
                  </div>
                  <div class="timeline-date" [class.active]="last">
                    <span class="date-day-month">{{ group.date | date: 'd MMMM' : undefined : locale() }}</span
                    ><br />
                    <span class="date-year">{{ group.date | date: 'yyyy' : undefined : locale() }}</span>
                  </div>
                  @if (group.images[0].description) {
                    <p class="timeline-description">{{ remarkPrefix() + group.images[0].description }}</p>
                  }
                </div>
              }
            </div>
          </div>
        } @else {
          <!-- Empty state -->
          <app-empty-widget [text]="emptyMessage()" />
        }
      }
    }
  </div>
</div>
